(function () {
  var OPEN_CLASS = "is-mobile-menu-open";

  function getActiveMenuId() {
    var root = document.documentElement;
    if (root.classList.contains("ab-menu-v2")) return "HeaderMobileMenu-v2";
    if (root.classList.contains("ab-menu-v1")) return "HeaderMobileMenu-v1";
    return null;
  }

  function getMenu(fromBtn) {
    var id =
      (fromBtn && fromBtn.getAttribute("aria-controls")) ||
      getActiveMenuId() ||
      "HeaderMobileMenu-v1";
    return document.getElementById(id);
  }

  function getOpenBtns(menu) {
    if (!menu || !menu.id) return [];
    return document.querySelectorAll(
      '.js-open-mobile-menu[aria-controls="' + menu.id + '"]'
    );
  }

  function setOpen(menu, isOpen) {
    if (!menu) return;

    if (isOpen) {
      menu.hidden = false;
      menu.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add(OPEN_CLASS);
      document.body.classList.add(OPEN_CLASS);

      var megaDetails = menu.querySelectorAll(".site-nav__details--mega");
      var anyOpen = menu.querySelector(".site-nav__details--mega[open]");
      if (megaDetails.length && !anyOpen) {
        megaDetails[0].open = true;
      }
    } else {
      menu.hidden = true;
      menu.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove(OPEN_CLASS);
      document.body.classList.remove(OPEN_CLASS);
    }

    getOpenBtns(menu).forEach(function (btn) {
      btn.classList.toggle("is-active", isOpen);
      btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  function bindMenu(menu) {
    if (!menu || menu.dataset.bound === "true") return;
    menu.dataset.bound = "true";

    getOpenBtns(menu).forEach(function (btn) {
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        setOpen(menu, menu.hidden);
      });
    });

    menu.querySelectorAll(".js-close-mobile-menu").forEach(function (btn) {
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        setOpen(menu, false);
      });
    });

    menu
      .querySelectorAll(".site-nav__details--mega")
      .forEach(function (details) {
        details.addEventListener("toggle", function () {
          if (!details.open) return;
          menu
            .querySelectorAll(".site-nav__details--mega")
            .forEach(function (other) {
              if (other !== details) other.open = false;
            });
        });
      });
  }

  function bind() {
    ["HeaderMobileMenu-v1", "HeaderMobileMenu-v2", "HeaderMobileMenu"].forEach(
      function (id) {
        bindMenu(document.getElementById(id));
      }
    );

    if (!window.__mobileMenuEscapeBound) {
      window.__mobileMenuEscapeBound = true;
      document.addEventListener("keyup", function (event) {
        if (event.key !== "Escape") return;
        ["HeaderMobileMenu-v1", "HeaderMobileMenu-v2", "HeaderMobileMenu"].forEach(
          function (id) {
            setOpen(document.getElementById(id), false);
          }
        );
      });
    }
  }

  function rebind() {
    ["HeaderMobileMenu-v1", "HeaderMobileMenu-v2", "HeaderMobileMenu"].forEach(
      function (id) {
        var menu = document.getElementById(id);
        if (menu) {
          menu.dataset.bound = "";
          setOpen(menu, false);
        }
      }
    );
    bind();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }

  document.addEventListener("shopify:section:load", rebind);
})();
